export const SidebarIcons = [
    {
      icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 10H20.5" stroke="currentColor" stroke-width="1.5"></path><mask id="path-2-inside-1_11931_4916" fill="white"><rect x="3" y="2" width="18" height="20" rx="1"></rect></mask><rect x="3" y="2" width="18" height="20" rx="1" stroke="currentColor" stroke-width="3" mask="url(#path-2-inside-1_11931_4916)"></rect><path d="M14 3.5V21" stroke="currentColor" stroke-width="1.5"></path></svg>`,
      text:"Templates",
      show:true
    },
    {
      icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.12482L10 17.8748" stroke="currentColor" stroke-width="1.6875" stroke-linecap="round"></path><path d="M7.59619 17.0311C7.1302 17.0311 6.75244 17.4088 6.75244 17.8748C6.75244 18.3408 7.1302 18.7186 7.59619 18.7186V17.0311ZM11.9939 18.7186C12.4599 18.7186 12.8377 18.3408 12.8377 17.8748C12.8377 17.4088 12.4599 17.0311 11.9939 17.0311V18.7186ZM7.59619 18.7186H11.9939V17.0311H7.59619V18.7186Z" fill="currentColor"></path><path d="M1.28125 5.49982C1.28125 5.96581 1.65901 6.34357 2.125 6.34357C2.59099 6.34357 2.96875 5.96581 2.96875 5.49982H1.28125ZM2.125 2.12482V1.28107C1.65901 1.28107 1.28125 1.65883 1.28125 2.12482H2.125ZM17.875 2.12482H18.7188C18.7188 1.65883 18.341 1.28107 17.875 1.28107V2.12482ZM17.0312 5.49982C17.0312 5.96581 17.409 6.34357 17.875 6.34357C18.341 6.34357 18.7188 5.96581 18.7188 5.49982H17.0312ZM2.96875 5.49982V2.12482H1.28125V5.49982H2.96875ZM2.125 2.96857H17.875V1.28107H2.125V2.96857ZM17.0312 2.12482V5.49982H18.7188V2.12482H17.0312Z" fill="currentColor"></path></svg>`,
      text:"Text",
      show:true
    },
    {
      icon:`<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M16.6849 8.92816L16.3202 9.10902V2.3438C16.3202 1.37455 15.5316 0.585999 14.5624 0.585999H2.2578C1.28855 0.585999 0.5 1.37455 0.5 2.3438V11.7578C0.5 12.727 1.28855 13.5156 2.2578 13.5156H7.57026V14.5312C7.57026 15.1835 8.02963 15.7303 8.64181 15.8658L8.16416 18.7318C8.10463 19.0888 8.38041 19.414 8.74212 19.414H11.0859C11.3699 19.414 11.613 19.2103 11.6628 18.9306L12.1921 15.9533L16.6849 18.1811C17.073 18.3736 17.5312 18.0911 17.5312 17.6562V9.45316C17.5311 9.01859 17.0736 8.73539 16.6849 8.92816ZM1.67187 11.7578V2.3438C1.67187 2.02071 1.93472 1.75786 2.2578 1.75786H14.5624C14.8855 1.75786 15.1483 2.02071 15.1483 2.3438V9.69011L12.0814 11.2109H8.93743C8.26353 11.2109 7.70229 11.7012 7.59076 12.3437H2.2578C1.93472 12.3437 1.67187 12.0809 1.67187 11.7578ZM8.93743 14.7265C8.82974 14.7265 8.74212 14.6389 8.74212 14.5312V12.5781C8.74212 12.4704 8.82974 12.3828 8.93743 12.3828H11.6327V14.7265H8.93743ZM9.4338 18.2421L9.82442 15.8984H11.0116L10.5949 18.2421H9.4338ZM16.3593 16.7116L12.8046 14.949V12.1603L16.3593 10.3976V16.7116Z" fill="currentColor"></path><path d="M19.5241 11.7477L20.1491 11.4743C20.4455 11.3446 20.5807 10.9991 20.451 10.7027C20.3213 10.4062 19.9758 10.2709 19.6794 10.4007L19.0544 10.6741C18.7579 10.8038 18.6227 11.1493 18.7524 11.4458C18.8822 11.7425 19.2279 11.8774 19.5241 11.7477Z" fill="currentColor"></path><path d="M20.1491 15.635L19.5241 15.3616C19.2276 15.2319 18.8821 15.3671 18.7524 15.6635C18.6227 15.96 18.7579 16.3055 19.0544 16.4352L19.6794 16.7086C19.9758 16.8383 20.3214 16.7031 20.451 16.4067C20.5807 16.1102 20.4455 15.7647 20.1491 15.635Z" fill="currentColor"></path><path d="M19.9141 12.9688H19.2891C18.9655 12.9688 18.7031 13.2311 18.7031 13.5547C18.7031 13.8783 18.9655 14.1406 19.2891 14.1406H19.9141C20.2377 14.1406 20.5 13.8783 20.5 13.5547C20.5 13.2311 20.2377 12.9688 19.9141 12.9688Z" fill="currentColor"></path><path d="M11.0159 7.57487C11.4469 7.3594 11.4472 6.74237 11.0159 6.52671L6.32843 4.18298C5.93972 3.98861 5.48047 4.27157 5.48047 4.70708V9.39454C5.48047 9.82966 5.93968 10.1131 6.32843 9.91864L11.0159 7.57487ZM6.65233 5.65512L9.44368 7.05077L6.65233 8.44646V5.65512Z" fill="currentColor"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>`,
      text:"Media",
      show:true
    },
    // {
    //   icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.666 0H14.334C17.738 0 20 2.43 20 5.917V14.083C20 17.57 17.738 20 14.333 20H5.666C2.262 20 0 17.57 0 14.083V5.917C0 2.433 2.267 0 5.666 0ZM14.334 1.503H5.666C3.122 1.503 1.503 3.24 1.503 5.917V14.083C1.503 14.828 1.628 15.5 1.863 16.083L3.013 14.686L3.521 14.059C4.801 12.475 5.973 11.79 7.509 12.433C7.742 12.531 7.941 12.637 8.197 12.794L8.857 13.221C9.517 13.639 9.831 13.699 10.314 13.437C10.742 13.205 11.044 12.881 11.501 12.177L11.801 11.699L12.005 11.371C12.189 11.081 12.32 10.891 12.48 10.684C13.538 9.314 15.188 8.868 16.63 9.736C17.255 10.112 17.709 10.486 18.497 11.238V5.917C18.497 3.237 16.883 1.503 14.334 1.503ZM18.497 13.315L18.447 13.271C18.3296 13.1622 18.2132 13.0521 18.098 12.941L17.399 12.269C16.729 11.632 16.345 11.319 15.855 11.024C15.114 10.578 14.289 10.801 13.669 11.602L13.544 11.772C13.502 11.829 13.46 11.892 13.414 11.96L13.024 12.581C12.284 13.777 11.837 14.322 11.029 14.759C10.035 15.299 9.225 15.186 8.239 14.605L7.801 14.328L7.433 14.09C7.27206 13.9862 7.10282 13.8959 6.927 13.82C6.257 13.539 5.661 13.85 4.839 14.825L3.032 17.03L2.729 17.397C3.446 18.101 4.449 18.496 5.666 18.496H14.333C16.883 18.496 18.497 16.762 18.497 14.082V13.314V13.315ZM4.27 6.8C4.27 6.10991 4.54414 5.44808 5.03211 4.96011C5.52008 4.47214 6.18191 4.198 6.872 4.198C7.56209 4.198 8.22392 4.47214 8.71189 4.96011C9.19986 5.44808 9.474 6.10991 9.474 6.8C9.474 7.49009 9.19986 8.15192 8.71189 8.63989C8.22392 9.12786 7.56209 9.402 6.872 9.402C6.18191 9.402 5.52008 9.12786 5.03211 8.63989C4.54414 8.15192 4.27 7.49009 4.27 6.8ZM7.969 6.8C7.95691 6.5169 7.83595 6.24941 7.63136 6.05336C7.42677 5.85732 7.15436 5.74787 6.871 5.74787C6.58764 5.74787 6.31523 5.85732 6.11064 6.05336C5.90605 6.24941 5.78508 6.5169 5.773 6.8C5.78508 7.0831 5.90605 7.35059 6.11064 7.54664C6.31523 7.74268 6.58764 7.85213 6.871 7.85213C7.15436 7.85213 7.42677 7.74268 7.63136 7.54664C7.83595 7.35059 7.95691 7.0831 7.969 6.8Z" fill="currentColor"></path></svg>`,
    //   text:"Photos",
    //   show:true
    // },
    // {
    //   icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.3877 15.39H8.8977C8.9177 15.47 8.93436 15.5667 8.9477 15.68C8.96103 15.7933 8.9677 15.9067 8.9677 16.02C8.9677 16.48 8.8977 16.9133 8.7577 17.32C8.6177 17.7267 8.3977 18.09 8.0977 18.41C7.7777 18.75 7.39436 19.0133 6.9477 19.2C6.50103 19.3867 5.99103 19.48 5.4177 19.48C4.8977 19.48 4.4077 19.3867 3.9477 19.2C3.4877 19.0133 3.0877 18.7533 2.7477 18.42C2.4077 18.0867 2.1377 17.6933 1.9377 17.24C1.7377 16.78 1.6377 16.28 1.6377 15.74C1.6377 15.2 1.7377 14.7033 1.9377 14.25C2.1377 13.79 2.4077 13.3933 2.7477 13.06C3.0877 12.7267 3.4877 12.4667 3.9477 12.28C4.4077 12.0933 4.8977 12 5.4177 12C5.9977 12 6.51436 12.1 6.9677 12.3C7.4277 12.5 7.82103 12.7767 8.1477 13.13L7.2177 14.04C6.98436 13.7933 6.72436 13.6067 6.4377 13.48C6.15103 13.3467 5.8077 13.28 5.4077 13.28C5.08103 13.28 4.77103 13.34 4.4777 13.46C4.18436 13.5733 3.9277 13.7367 3.7077 13.95C3.4877 14.1633 3.31103 14.4233 3.1777 14.73C3.05103 15.03 2.9877 15.3667 2.9877 15.74C2.9877 16.1133 3.05103 16.4533 3.1777 16.76C3.31103 17.06 3.4877 17.3167 3.7077 17.53C3.93436 17.7433 4.19436 17.91 4.4877 18.03C4.78103 18.1433 5.09436 18.2 5.4277 18.2C5.8077 18.2 6.1277 18.1467 6.3877 18.04C6.65436 17.9267 6.88103 17.7833 7.0677 17.61C7.20103 17.49 7.31436 17.34 7.4077 17.16C7.5077 16.9733 7.58436 16.7667 7.6377 16.54H5.3877V15.39Z" fill="currentColor"></path><path d="M10.0834 12.16H11.4334V19.32H10.0834V12.16Z" fill="currentColor"></path><path d="M12.8764 12.16H17.4164V13.44H14.2264V15.18H17.0964V16.46H14.2264V19.32H12.8764V12.16Z" fill="currentColor"></path><path d="M3 11V3C3 1.89543 3.89543 1 5 1H12M12 1L17 6M12 1V5C12 5.55228 12.4477 6 13 6H17M17 6V11" stroke="currentColor" stroke-width="1.3"></path></svg>`,
    //   text:"Giphy",
    //   show:true
    // },
    // {
    //   icon:`<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M16.6849 8.92816L16.3202 9.10902V2.3438C16.3202 1.37455 15.5316 0.585999 14.5624 0.585999H2.2578C1.28855 0.585999 0.5 1.37455 0.5 2.3438V11.7578C0.5 12.727 1.28855 13.5156 2.2578 13.5156H7.57026V14.5312C7.57026 15.1835 8.02963 15.7303 8.64181 15.8658L8.16416 18.7318C8.10463 19.0888 8.38041 19.414 8.74212 19.414H11.0859C11.3699 19.414 11.613 19.2103 11.6628 18.9306L12.1921 15.9533L16.6849 18.1811C17.073 18.3736 17.5312 18.0911 17.5312 17.6562V9.45316C17.5311 9.01859 17.0736 8.73539 16.6849 8.92816ZM1.67187 11.7578V2.3438C1.67187 2.02071 1.93472 1.75786 2.2578 1.75786H14.5624C14.8855 1.75786 15.1483 2.02071 15.1483 2.3438V9.69011L12.0814 11.2109H8.93743C8.26353 11.2109 7.70229 11.7012 7.59076 12.3437H2.2578C1.93472 12.3437 1.67187 12.0809 1.67187 11.7578ZM8.93743 14.7265C8.82974 14.7265 8.74212 14.6389 8.74212 14.5312V12.5781C8.74212 12.4704 8.82974 12.3828 8.93743 12.3828H11.6327V14.7265H8.93743ZM9.4338 18.2421L9.82442 15.8984H11.0116L10.5949 18.2421H9.4338ZM16.3593 16.7116L12.8046 14.949V12.1603L16.3593 10.3976V16.7116Z" fill="currentColor"></path><path d="M19.5241 11.7477L20.1491 11.4743C20.4455 11.3446 20.5807 10.9991 20.451 10.7027C20.3213 10.4062 19.9758 10.2709 19.6794 10.4007L19.0544 10.6741C18.7579 10.8038 18.6227 11.1493 18.7524 11.4458C18.8822 11.7425 19.2279 11.8774 19.5241 11.7477Z" fill="currentColor"></path><path d="M20.1491 15.635L19.5241 15.3616C19.2276 15.2319 18.8821 15.3671 18.7524 15.6635C18.6227 15.96 18.7579 16.3055 19.0544 16.4352L19.6794 16.7086C19.9758 16.8383 20.3214 16.7031 20.451 16.4067C20.5807 16.1102 20.4455 15.7647 20.1491 15.635Z" fill="currentColor"></path><path d="M19.9141 12.9688H19.2891C18.9655 12.9688 18.7031 13.2311 18.7031 13.5547C18.7031 13.8783 18.9655 14.1406 19.2891 14.1406H19.9141C20.2377 14.1406 20.5 13.8783 20.5 13.5547C20.5 13.2311 20.2377 12.9688 19.9141 12.9688Z" fill="currentColor"></path><path d="M11.0159 7.57487C11.4469 7.3594 11.4472 6.74237 11.0159 6.52671L6.32843 4.18298C5.93972 3.98861 5.48047 4.27157 5.48047 4.70708V9.39454C5.48047 9.82966 5.93968 10.1131 6.32843 9.91864L11.0159 7.57487ZM6.65233 5.65512L9.44368 7.05077L6.65233 8.44646V5.65512Z" fill="currentColor"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>`,
    //   text:"Pexels",
    //   show:true
    // },
    {
      icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M7.85714 0H0.714286C0.319481 0 0 0.319481 0 0.714286V7.85714C0 8.25195 0.319481 8.57143 0.714286 8.57143H7.85714C8.25195 8.57143 8.57143 8.25195 8.57143 7.85714V5.71429V0.714286C8.57143 0.319481 8.25195 0 7.85714 0ZM7.14286 7.14286H1.42857V1.42857H7.14286V7.14286Z" fill="currentColor"></path><path d="M7.85714 11.4286H0.714286C0.319481 11.4286 0 11.7481 0 12.1429V19.2857C0 19.6805 0.319481 20 0.714286 20H7.85714C8.25195 20 8.57143 19.6805 8.57143 19.2857V12.1429C8.57143 11.7481 8.25195 11.4286 7.85714 11.4286ZM7.14286 18.5715H1.42857V12.8572H7.14286V18.5715Z" fill="currentColor"></path><path d="M19.2854 11.4286H14.2854H12.1425C11.7477 11.4286 11.4282 11.7481 11.4282 12.1429V19.2857C11.4282 19.6805 11.7477 20 12.1425 20H19.2854C19.6802 20 19.9996 19.6805 19.9996 19.2857V12.1429C19.9996 11.7481 19.6802 11.4286 19.2854 11.4286ZM18.5711 18.5715H12.8568V12.8572H18.5711V18.5715Z" fill="currentColor"></path><path d="M19.7911 6.2193C20.0701 5.94029 20.0701 5.48826 19.7911 5.20925L14.7911 0.209253C14.5121 -0.0697511 14.06 -0.0697511 13.781 0.209253L8.78104 5.20925C8.64152 5.34878 8.57178 5.5315 8.57178 5.71428C8.57178 5.89705 8.64152 6.07977 8.78104 6.2193L13.781 11.2193C13.9206 11.3588 14.1033 11.4286 14.2861 11.4286C14.4688 11.4286 14.6516 11.3588 14.7911 11.2193L19.7911 6.2193ZM10.2961 5.71428L14.2861 1.72432L18.276 5.71428L14.2861 9.70423L10.2961 5.71428Z" fill="currentColor"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white"></rect></clipPath></defs></svg>`,
      text:"Apps",
      show:true
    },
    {
      icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.73446 19.3463C4.69339 19.2057 0.65 15.0751 0.65 10C0.65 4.83614 4.83614 0.65 10 0.65C15.0751 0.65 19.2057 4.69339 19.3463 9.73446L9.73446 19.3463Z" fill="#DDE2E5" stroke="currentColor" stroke-width="1.3"></path><path d="M14.712 6.43567C14.6605 6.9329 14.464 7.34817 14.2118 7.62069C13.9596 7.89306 13.6775 8.00148 13.4233 7.97513C13.1691 7.94878 12.9152 7.78478 12.7243 7.46648C12.5333 7.14801 12.4262 6.70127 12.4778 6.20405C12.5293 5.70682 12.7258 5.29155 12.978 5.01903C13.2302 4.74666 13.5123 4.63823 13.7665 4.66459C14.0207 4.69094 14.2746 4.85494 14.4655 5.17324C14.6565 5.49171 14.7636 5.93845 14.712 6.43567Z" stroke="currentColor"></path><path d="M7.96014 6.20449C8.01312 6.70156 7.90732 7.14862 7.71726 7.46763C7.5273 7.78649 7.27386 7.95122 7.01975 7.97831C6.76564 8.0054 6.48317 7.89779 6.23026 7.62614C5.97722 7.35436 5.77956 6.93966 5.72657 6.44258C5.67359 5.94551 5.77939 5.49846 5.96945 5.17944C6.15942 4.86059 6.41286 4.69585 6.66696 4.66877C6.92107 4.64168 7.20354 4.74929 7.45645 5.02093C7.70949 5.29272 7.90715 5.70742 7.96014 6.20449Z" stroke="currentColor"></path><path d="M12.1958 16.5C9.03265 16.5 6.29829 15.1642 5 12.5" stroke="currentColor" stroke-width="1.3"></path><mask id="StickersIcon__path-5-inside-1" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.8482 10.1518C18.7441 9.42372 17.4215 9 16 9C14.249 9 12.8387 10.2826 11.6238 11.3874C11.5823 11.4252 11.5411 11.4627 11.5 11.5C10.0895 12.7806 9 13.9448 9 16C9 17.4215 9.42372 18.7441 10.1518 19.8482L19.8482 10.1518Z"></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M19.8482 10.1518C18.7441 9.42372 17.4215 9 16 9C14.249 9 12.8387 10.2826 11.6238 11.3874C11.5823 11.4252 11.5411 11.4627 11.5 11.5C10.0895 12.7806 9 13.9448 9 16C9 17.4215 9.42372 18.7441 10.1518 19.8482L19.8482 10.1518Z" fill="#DDE2E5"></path><path d="M19.8482 10.1518L20.7675 11.071L21.8946 9.94387L20.5638 9.06644L19.8482 10.1518ZM11.6238 11.3874L12.4985 12.3492L12.4985 12.3492L11.6238 11.3874ZM11.5 11.5L12.3738 12.4625L11.5 11.5ZM10.1518 19.8482L9.06644 20.5638L9.94387 21.8946L11.071 20.7675L10.1518 19.8482ZM16 10.3C17.1594 10.3 18.2343 10.6448 19.1326 11.2371L20.5638 9.06644C19.2538 8.20267 17.6836 7.7 16 7.7V10.3ZM12.4985 12.3492C13.1207 11.7833 13.695 11.2654 14.3072 10.8772C14.9058 10.4975 15.4542 10.3 16 10.3V7.7C14.7948 7.7 13.7625 8.14379 12.9146 8.68158C12.0801 9.21085 11.3418 9.88671 10.7492 10.4257L12.4985 12.3492ZM12.3738 12.4625C12.4154 12.4248 12.4571 12.3869 12.4985 12.3492L10.7492 10.4257C10.7076 10.4635 10.6667 10.5007 10.6262 10.5375L12.3738 12.4625ZM10.3 16C10.3 14.5441 10.9931 13.7161 12.3738 12.4625L10.6262 10.5375C9.18591 11.8451 7.7 13.3455 7.7 16H10.3ZM11.2371 19.1326C10.6448 18.2343 10.3 17.1594 10.3 16H7.7C7.7 17.6836 8.20267 19.2538 9.06644 20.5638L11.2371 19.1326ZM11.071 20.7675L20.7675 11.071L18.929 9.23252L9.23252 18.929L11.071 20.7675Z" fill="currentColor" mask="url(#StickersIcon__path-5-inside-1)"></path></svg>`,
      text:"Stickers",
      show:true
    },
    {
      icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.1715 12.9016C16.2644 12.9945 16.3904 13.0467 16.5217 13.0467C16.6531 13.0467 16.7791 12.9945 16.8719 12.9016C16.9648 12.8087 17.017 12.6827 17.017 12.5514V11.7649C17.017 11.6335 16.9648 11.5076 16.8719 11.4147C16.7791 11.3218 16.6531 11.2696 16.5217 11.2696C16.3904 11.2696 16.2644 11.3218 16.1715 11.4147C16.0786 11.5076 16.0265 11.6335 16.0265 11.7649V12.5514C16.0265 12.6827 16.0786 12.8087 16.1715 12.9016Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M16.0263 3.97355V7.17828C16.0263 7.30963 16.0784 7.4356 16.1713 7.52849L16.3304 7.36939L16.1713 7.52849C16.2642 7.62137 16.3902 7.67355 16.5215 7.67355C16.6529 7.67355 16.7788 7.62137 16.8717 7.52849C16.9646 7.43561 17.0168 7.30963 17.0168 7.17828V3.47828C17.0168 3.34692 16.9646 3.22095 16.8717 3.12807C16.7788 3.03519 16.6529 2.98301 16.5215 2.98301H3.47828C3.34692 2.98301 3.22095 3.03519 3.12807 3.12807C3.03519 3.22095 2.98301 3.34692 2.98301 3.47828V16.5215C2.98301 16.6529 3.03519 16.7788 3.12807 16.8717C3.22095 16.9646 3.34692 17.0168 3.47828 17.0168H16.5215C16.6529 17.0168 16.7789 16.9646 16.8717 16.8717C16.9646 16.7789 17.0168 16.6529 17.0168 16.5215V14.4431C17.0168 14.3118 16.9646 14.1858 16.8717 14.0929C16.7789 14.0001 16.6529 13.9479 16.5215 13.9479C16.3902 13.9479 16.2642 14.0001 16.1713 14.0929C16.0784 14.1858 16.0263 14.3118 16.0263 14.4431V16.0263H3.97355V3.97355H16.0263Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M16.1715 10.223C16.2644 10.3159 16.3904 10.368 16.5217 10.368C16.6531 10.368 16.7791 10.3159 16.8719 10.223C16.9648 10.1301 17.017 10.0041 17.017 9.87278V9.07007C17.017 8.93872 16.9648 8.81275 16.8719 8.71987C16.7791 8.62698 16.6531 8.5748 16.5217 8.5748C16.3904 8.5748 16.2644 8.62698 16.1715 8.71987C16.0786 8.81275 16.0265 8.93872 16.0265 9.07007V9.87278C16.0265 10.0041 16.0786 10.1301 16.1715 10.223Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M16.171 2.34668C16.2639 2.43956 16.3899 2.49174 16.5212 2.49174C16.6526 2.49174 16.7786 2.43956 16.8715 2.34668C16.9643 2.2538 17.0165 2.12783 17.0165 1.99647V0.810798C17.0165 0.679442 16.9643 0.553469 16.8715 0.460589C16.7786 0.367708 16.6526 0.315527 16.5212 0.315527C16.3899 0.315527 16.2639 0.367707 16.171 0.460589C16.0782 0.55347 16.026 0.679444 16.026 0.810798V1.99647C16.026 2.12783 16.0782 2.2538 16.171 2.34668Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M3.12856 2.34668C3.22144 2.43956 3.34741 2.49174 3.47877 2.49174C3.61012 2.49174 3.73609 2.43956 3.82898 2.34668C3.92186 2.2538 3.97404 2.12783 3.97404 1.99647V0.810798C3.97404 0.679444 3.92186 0.55347 3.82898 0.460589C3.73609 0.367707 3.61012 0.315527 3.47877 0.315527C3.34741 0.315527 3.22144 0.367707 3.12856 0.460589C3.03568 0.55347 2.9835 0.679444 2.9835 0.810798V1.99647C2.9835 2.12783 3.03568 2.2538 3.12856 2.34668Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M16.171 19.5396C16.2639 19.6324 16.3899 19.6846 16.5212 19.6846C16.6526 19.6846 16.7786 19.6324 16.8715 19.5396C16.9643 19.4467 17.0165 19.3207 17.0165 19.1893V18.0037C17.0165 17.8723 16.9643 17.7463 16.8715 17.6535C16.7786 17.5606 16.6526 17.5084 16.5212 17.5084C16.3899 17.5084 16.2639 17.5606 16.171 17.6535C16.0782 17.7463 16.026 17.8723 16.026 18.0037V19.1893C16.026 19.3207 16.0782 19.4467 16.171 19.5396Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M3.12856 19.5396C3.22144 19.6324 3.34741 19.6846 3.47877 19.6846C3.61012 19.6846 3.73609 19.6324 3.82898 19.5396C3.92186 19.4467 3.97404 19.3207 3.97404 19.1893V18.0037C3.97404 17.8723 3.92186 17.7463 3.82898 17.6535C3.73609 17.5606 3.61012 17.5084 3.47877 17.5084C3.34741 17.5084 3.22144 17.5606 3.12856 17.6535C3.03568 17.7463 2.9835 17.8723 2.9835 18.0037V19.1893C2.9835 19.3207 3.03568 19.4467 3.12856 19.5396Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M18.0037 17.0165H19.1893C19.3207 17.0165 19.4467 16.9643 19.5396 16.8715C19.6324 16.7786 19.6846 16.6526 19.6846 16.5212C19.6846 16.3899 19.6324 16.2639 19.5396 16.171C19.4467 16.0782 19.3207 16.026 19.1893 16.026H18.0037C17.8723 16.026 17.7463 16.0782 17.6535 16.171C17.5606 16.2639 17.5084 16.3899 17.5084 16.5212C17.5084 16.6526 17.5606 16.7786 17.6535 16.8715C17.7463 16.9643 17.8723 17.0165 18.0037 17.0165Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M18.0037 3.97404H19.1893C19.3207 3.97404 19.4467 3.92186 19.5396 3.82898C19.6324 3.73609 19.6846 3.61012 19.6846 3.47877C19.6846 3.34741 19.6324 3.22144 19.5396 3.12856C19.4467 3.03568 19.3207 2.9835 19.1893 2.9835H18.0037C17.8723 2.9835 17.7463 3.03568 17.6535 3.12856C17.5606 3.22144 17.5084 3.34741 17.5084 3.47877C17.5084 3.61012 17.5606 3.73609 17.6535 3.82898C17.7463 3.92186 17.8723 3.97404 18.0037 3.97404Z" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M1.99647 17.0165H0.810798C0.679442 17.0165 0.553469 16.9643 0.460589 16.8715C0.367708 16.7786 0.315527 16.6526 0.315527 16.5212C0.315527 16.3899 0.367707 16.2639 0.460589 16.171C0.55347 16.0782 0.679444 16.026 0.810798 16.026H1.99647C2.12783 16.026 2.2538 16.0782 2.34668 16.171M1.99647 17.0165L2.34668 16.171M1.99647 17.0165C2.12783 17.0165 2.2538 16.9643 2.34668 16.8715C2.43956 16.7786 2.49174 16.6526 2.49174 16.5212C2.49174 16.3899 2.43956 16.2639 2.34668 16.171M1.99647 17.0165L2.34668 16.171" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path><path d="M1.99647 3.97404H0.810798C0.679444 3.97404 0.55347 3.92186 0.460589 3.82898C0.367707 3.73609 0.315527 3.61012 0.315527 3.47877C0.315527 3.34741 0.367707 3.22144 0.460589 3.12856C0.55347 3.03568 0.679444 2.9835 0.810798 2.9835H1.99647C2.12783 2.9835 2.2538 3.03568 2.34668 3.12856M1.99647 3.97404L2.34668 3.12856M1.99647 3.97404C2.12783 3.97404 2.2538 3.92186 2.34668 3.82898C2.43956 3.73609 2.49174 3.61012 2.49174 3.47877C2.49174 3.34741 2.43956 3.22144 2.34668 3.12856M1.99647 3.97404L2.34668 3.12856" fill="currentColor" stroke="currentColor" stroke-width="0.45"></path></svg>`,
      text:"Frames",
      show:true
    },
    {
      icon:`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="DashboardsIcon__path-1-inside-1" fill="white"><rect width="9" height="5" rx="1.3"></rect></mask><rect width="9" height="5" rx="1.3" stroke="currentColor" stroke-width="2.8" mask="url(#DashboardsIcon__path-1-inside-1)"></rect><mask id="DashboardsIcon__path-2-inside-2" fill="white"><rect x="11" y="15" width="9" height="5" rx="1.3"></rect></mask><rect x="11" y="15" width="9" height="5" rx="1.3" stroke="currentColor" stroke-width="2.8" mask="url(#DashboardsIcon__path-2-inside-2)"></rect><mask id="DashboardsIcon__path-3-inside-3" fill="white"><rect x="11" width="9" height="13" rx="1.3"></rect></mask><rect x="11" width="9" height="13" rx="1.3" stroke="currentColor" stroke-width="2.8" mask="url(#DashboardsIcon__path-3-inside-3)"></rect><mask id="DashboardsIcon__path-4-inside-4" fill="white"><rect y="7" width="9" height="13" rx="1.3"></rect></mask><rect y="7" width="9" height="13" rx="1.3" stroke="currentColor" stroke-width="2.8" mask="url(#DashboardsIcon__path-4-inside-4)"></rect></svg>`,
      text:"Dashboards",
      show:true
    },
    {
      icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.616 2.00001H11.381C10.685 2.00001 10.019 2.27201 9.52803 2.75501C9.09536 3.1793 8.82864 3.7443 8.77603 4.34801L8.76703 4.54201C8.76307 4.8427 8.64037 5.12962 8.42568 5.34019C8.21099 5.55076 7.92174 5.66788 7.62103 5.66601C7.47436 5.66367 7.32973 5.63134 7.19603 5.57101L7.06203 5.50101C6.46102 5.16862 5.75431 5.08295 5.09128 5.26209C4.42826 5.44124 3.86086 5.87117 3.50903 6.46101L2.85903 7.50701C2.5273 8.06517 2.42173 8.72912 2.56398 9.36264C2.70623 9.99617 3.08551 10.5512 3.62403 10.914L3.77903 11.012C4.16103 11.228 4.37903 11.599 4.37903 12C4.37903 12.369 4.19503 12.714 3.88603 12.923L3.78103 12.988C3.2234 13.3044 2.80686 13.8209 2.6158 14.4329C2.42474 15.0448 2.47344 15.7066 2.75203 16.284L2.83703 16.444L3.47403 17.522C3.81656 18.1183 4.38089 18.555 5.04403 18.737C5.64003 18.902 6.27403 18.857 6.83803 18.608L7.01603 18.521C7.31603 18.351 7.62503 18.311 7.91603 18.387C8.20603 18.463 8.45303 18.65 8.60303 18.906C8.68503 19.042 8.73303 19.182 8.75103 19.328L8.75903 19.475C8.75803 20.85 9.93203 22 11.381 22H12.616C13.985 22 15.12 20.97 15.231 19.641L15.239 19.47C15.2355 19.3184 15.2626 19.1677 15.3187 19.0268C15.3747 18.886 15.4586 18.7578 15.5653 18.6501C15.672 18.5424 15.7993 18.4573 15.9396 18.3999C16.08 18.3425 16.2304 18.314 16.382 18.316C16.522 18.32 16.675 18.354 16.817 18.416L16.953 18.485C18.101 19.135 19.606 18.801 20.381 17.709L20.481 17.557L21.14 16.48C21.3148 16.1889 21.429 15.8656 21.4757 15.5293C21.5225 15.193 21.5008 14.8507 21.412 14.523C21.251 13.9365 20.8866 13.4265 20.384 13.084L20.217 12.979C20.082 12.9066 19.9628 12.8078 19.8668 12.6884C19.7708 12.569 19.6998 12.4315 19.658 12.284C19.6195 12.1423 19.6099 11.9942 19.6298 11.8487C19.6497 11.7032 19.6988 11.5632 19.774 11.437C19.858 11.293 19.971 11.173 20.105 11.081L20.362 10.922C20.8702 10.5837 21.2394 10.0735 21.4018 9.48493C21.5641 8.8964 21.5089 8.26906 21.246 7.71801L21.189 7.60701C21.1766 7.57775 21.1622 7.54935 21.146 7.52201L20.533 6.47901C19.851 5.31901 18.376 4.86901 17.146 5.43601L16.982 5.51801C16.7132 5.6804 16.3911 5.72966 16.086 5.65501C15.7956 5.58215 15.5457 5.39738 15.391 5.14101C15.3137 5.01428 15.2646 4.8724 15.247 4.72501L15.238 4.57801C15.26 3.95001 14.993 3.27701 14.498 2.77801C14.2511 2.53063 13.9577 2.33453 13.6347 2.20101C13.3118 2.06748 12.9655 1.99917 12.616 2.00001ZM11.381 3.44801H12.616C12.926 3.44801 13.223 3.57001 13.439 3.78801C13.655 4.00501 13.771 4.29901 13.762 4.60201L13.776 4.85501C13.82 5.24001 13.936 5.57501 14.118 5.87601C14.468 6.46001 15.042 6.88601 15.714 7.05601C16.3856 7.22714 17.0973 7.12955 17.698 6.78401L17.802 6.73301L17.912 6.68901C18.1607 6.61101 18.4283 6.61923 18.6717 6.71234C18.9151 6.80544 19.1199 6.97798 19.253 7.20201L19.838 8.19701L19.85 8.22501L19.921 8.35901C20.158 8.85501 19.961 9.48301 19.448 9.77601L19.288 9.87601C18.946 10.107 18.685 10.387 18.495 10.713C18.3227 11.0027 18.2105 11.3241 18.165 11.6581C18.1194 11.992 18.1416 12.3318 18.23 12.657C18.3946 13.2575 18.7721 13.7775 19.292 14.12L19.564 14.288C19.7878 14.4486 19.9431 14.6873 19.9994 14.9568C20.0557 15.2264 20.0088 15.5073 19.868 15.744L19.224 16.796L19.151 16.906C18.853 17.326 18.265 17.481 17.769 17.268L17.453 17.11C17.123 16.9612 16.7669 16.8793 16.405 16.869C15.7048 16.8612 15.03 17.1308 14.528 17.619C14.2848 17.8561 14.0916 18.1396 13.96 18.4528C13.8284 18.7659 13.7611 19.1023 13.762 19.442L13.757 19.552C13.71 20.102 13.214 20.552 12.617 20.552H11.38C10.79 20.552 10.303 20.114 10.241 19.552L10.221 19.198C10.1608 18.6784 9.94463 18.1891 9.60103 17.7947C9.25744 17.4002 8.80249 17.119 8.29603 16.988C7.62523 16.8123 6.91232 16.9064 6.31003 17.25L6.20103 17.302C5.96154 17.4003 5.69595 17.415 5.44703 17.344C5.15582 17.2634 4.90842 17.0707 4.75903 16.808L4.12903 15.745L4.07303 15.638C3.83503 15.144 4.03303 14.516 4.54503 14.226L4.70103 14.13C5.43303 13.634 5.85703 12.845 5.85703 12C5.85703 11.143 5.42103 10.347 4.70303 9.87101L4.44303 9.70901C4.21628 9.54909 4.05813 9.30958 4.00012 9.03824C3.94211 8.7669 3.98849 8.48367 4.13003 8.24501L4.78003 7.19901C4.93376 6.93651 5.18422 6.7447 5.47771 6.66469C5.77119 6.58468 6.08435 6.62285 6.35003 6.77101L6.54303 6.87101C6.90303 7.03301 7.25503 7.11101 7.61303 7.11401C8.99903 7.11401 10.133 6.07101 10.236 4.74201L10.249 4.43701C10.269 4.20701 10.385 3.96201 10.574 3.77601C10.788 3.56601 11.078 3.44801 11.38 3.44801H11.381ZM12.003 8.73201C10.161 8.73201 8.66703 10.195 8.66703 12C8.66703 13.805 10.161 15.268 12.003 15.268C13.845 15.268 15.339 13.805 15.339 12C15.339 10.195 13.845 8.73201 12.003 8.73201ZM12.003 10.18C13.029 10.18 13.861 10.995 13.861 12C13.861 13.005 13.029 13.82 12.003 13.82C10.977 13.82 10.145 13.005 10.145 12C10.145 10.995 10.977 10.18 12.003 10.18Z" fill="currentColor"></path></svg>`,
      text:"Settings",
      show:false
    },
  ];

  export const DefaultToolbar = [
    {
        icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 hover:text-gray-500 transition-colors cursor-pointer" data-state="tooltip-hidden" data-reach-tooltip-trigger=""><path d="M12 5L12 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M9.86365 18.25C9.44943 18.25 9.11365 18.5858 9.11365 19C9.11365 19.4142 9.44943 19.75 9.86365 19.75V18.25ZM13.7727 19.75C14.187 19.75 14.5227 19.4142 14.5227 19C14.5227 18.5858 14.187 18.25 13.7727 18.25V19.75ZM9.86365 19.75H13.7727V18.25H9.86365V19.75Z" fill="currentColor"></path><path d="M4.25 8C4.25 8.41421 4.58579 8.75 5 8.75C5.41421 8.75 5.75 8.41421 5.75 8H4.25ZM5 5V4.25C4.58579 4.25 4.25 4.58579 4.25 5H5ZM19 5H19.75C19.75 4.58579 19.4142 4.25 19 4.25V5ZM18.25 8C18.25 8.41421 18.5858 8.75 19 8.75C19.4142 8.75 19.75 8.41421 19.75 8H18.25ZM5.75 8V5H4.25V8H5.75ZM5 5.75H19V4.25H5V5.75ZM18.25 5V8H19.75V5H18.25Z" fill="currentColor"></path></svg>`,
        text:"Text"
      },
    {
        icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 hover:text-gray-500 transition-colors cursor-pointer" data-state="tooltip-hidden" data-reach-tooltip-trigger=""><circle cx="12" cy="12" r="7.25" stroke="currentColor" stroke-width="1.5"></circle></svg>`,
        text:"Ellipse"
      },
    {
        icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 hover:text-gray-500 transition-colors cursor-pointer" data-state="tooltip-hidden" data-reach-tooltip-trigger=""><path d="M12.2835 5.875C12.3797 5.70833 12.6203 5.70833 12.7165 5.875L20.0777 18.625C20.1739 18.7917 20.0537 19 19.8612 19H5.13878C4.94633 19 4.82605 18.7917 4.92228 18.625L12.2835 5.875Z" stroke="currentColor" stroke-width="1.5"></path></svg>`,
        text:"Triangle"
      },
    {
        icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 hover:text-gray-500 transition-colors cursor-pointer" data-state="tooltip-hidden" data-reach-tooltip-trigger=""><mask id="RectangleShapeIcon__path-1-inside-1" fill="white"><rect x="4" y="4" width="16" height="16" rx="1"></rect></mask><rect x="4" y="4" width="16" height="16" rx="1" stroke="currentColor" stroke-width="3" mask="url(#RectangleShapeIcon__path-1-inside-1)"></rect></svg>`,
        text:"Rectangle"
      },
    {
        icon:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 hover:text-gray-500 transition-colors cursor-pointer" data-state="tooltip-hidden" data-reach-tooltip-trigger=""><path d="M5 19L19 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>`,
        text:"Line"
      },
  ]

  export const BackAngle = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`

  export const Stickers = [
    {
      category:"arrows",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52]
    },
    {
      category:"badges",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
    {
      category:"brushes",
      childrens:[1,2,3,4,5,6,7,8,9,10]
    },
    {
        category: 'grlpwr',
        childrens: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    },
    {
        category: 'travel',
        childrens: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    },
    {
        category: 'love',
        childrens: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    },
    {
        category: 'specialdays',
        childrens: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    },
    {
      category:"finance",
      childrens:[1,2,3,4,5,6,7,8,9,10]
    },
    {
      category:"food",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
    {
      category:"frames",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
    {
      category:"papers",
      childrens:[1,2,3,4,5,6,7,8,9,10]
    },
    {
      category:"patterns",
      childrens:[1,2,3,4,5,6,7,8,9,10]
    },
    {
      category:"ribbons",
      childrens:[21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
    },
    {
      category:"shapes",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
    {
      category:"shopping",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
    {
      category:"weather",
      childrens:[1,2,3,4,5,6,7,8,9,10]
    },
    {
      category:"words",
      childrens:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
    },
]


export const Fontfamilies = [
  {
      name:"arial",
      value:"arial",
      fw:[
          {
              name:"Regular",
              value:400
          },
          {
              name:"Medium",
              value:500
          }
      ]
  },
  {
      name:"Abril Fatface",
      value:"Abril Fatface",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Anton",
      value:"Anton",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Bebas Neue",
      value:"Bebas Neue",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Blinker",
      value:"Blinker",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"ExtraBold",
              value:800
          },
          {
              name:"Black",
              value:900
          },
      ]
  },
  {
      name:"Borel",
      value:"Borel",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Bungee Inline",
      value:"Bungee Inline",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Bungee Outline",
      value:"Bungee Outline",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Cairo Play",
      value:"Cairo Play",
      fw:[
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"ExtraBold",
              value:800
          },
          {
              name:"Black",
              value:900
          },
      ]
  },
  {
      name:"Great Vibes",
      value:"Great Vibes",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Chewy",
      value:"Chewy",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Kalnia",
      value:"Kalnia",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"Bold",
              value:700
          }
      ]
  },
  {
      name:"League Gothic",
      value:"League Gothic",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Monoton",
      value:"Monoton",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Montserrat",
      value:"Montserrat",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"Thin Italic",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"ExtraLight Italic",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"SemiBold Italic",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
          {
              name:"ExtraBold ",
              value:800
          },
          {
              name:"ExtraBold Italic",
              value:800
          },
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
  {
      name:"Nixie One",
      value:"Nixie One",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Nunito",
      value:"Nunito",
      fw:[
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"ExtraLight Italic",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"SemiBold Italic",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
          {
              name:"ExtraBold ",
              value:800
          },
          {
              name:"ExtraBold Italic",
              value:800
          },
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
  {
      name:"Oswald",
      value:"Oswald",
      fw:[
        
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"Bold",
              value:700
          }
      ]
  },
  {
      name:"Pacifico",
      value:"Pacifico",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Poppins",
      value:"Poppins",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"Thin Italic",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"ExtraLight Italic",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"SemiBold Italic",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
          {
              name:"ExtraBold ",
              value:800
          },
          {
              name:"ExtraBold Italic",
              value:800
          },
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
  {
      name:"Quicksand",
      value:"Quicksand",
      fw:[
          {
              name:"Light",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"Bold",
              value:700
          }
      ]
  },
  {
      name:"Sacramento",
      value:"Sacramento",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Rubik Dirt",
      value:"Rubik Dirt",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Send Flowers",
      value:"Send Flowers",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Six Caps",
      value:"Six Caps",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Ubuntu",
      value:"Ubuntu",
      fw:[
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          }
        
      ]
  },
  {
      name:"Wire One",
      value:"Wire One",
      fw:[
          {
              name:"Regular",
              value:400
          }
      ]
  },
  {
      name:"Alumni Sans Pinstripe",
      value:"Alumni Sans Pinstripe",
      fw:[
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
      ]
  },
  {
      name:"Raleway Dots",
      value:"Raleway Dots",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Coiny",
      value:"Coiny",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Mr De Haviland",
      value:"Mr De Haviland",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Ms Madi",
      value:"Ms Madi",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Seaweed Script",
      value:"Seaweed Script",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Damion",
      value:"Damion",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Mr Dafoe",
      value:"Mr Dafoe",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Gasoek One",
      value:"Gasoek One",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Train One",
      value:"Train One",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Redressed",
      value:"Redressed",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Wendy One",
      value:"Wendy One",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Notable",
      value:"Notable",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Creepster",
      value:"Creepster",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Ultra",
      value:"Ultra",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Smooch",
      value:"Smooch",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Rubik Glitch",
      value:"Rubik Glitch",
      fw:[
          {
              name:"Regular",
              value:400
          },
      ]
  },
  {
      name:"Roboto",
      value:"Roboto",
      fw:[
      {
              name:"Thin",
              value:100
          },
          {
              name:"Thin Italic",
              value:100
          },
       
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
       
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
        
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
  {
      name:"Space Mono",
      value:"Space Mono",
      fw:[
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
      ]
  },
  {
      name:"Fraunces",
      value:"Fraunces",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"Thin Italic",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"ExtraLight Italic",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"SemiBold Italic",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
          {
              name:"ExtraBold ",
              value:800
          },
          {
              name:"ExtraBold Italic",
              value:800
          },
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
  {
      name:"Work Sans",
      value:"Work Sans",
      fw:[
          {
              name:"Thin",
              value:100
          },
          {
              name:"Thin Italic",
              value:100
          },
          {
              name:"ExtraLight",
              value:200
          },
          {
              name:"ExtraLight Italic",
              value:200
          },
          {
              name:"Light",
              value:300
          },
          {
              name:"Light Italic",
              value:300
          },
          {
              name:"Regular",
              value:400
          },
          {
              name:"Regular Italic",
              value:400
          },
          {
              name:"Medium",
              value:500
          },
          {
              name:"Medium Italic",
              value:500
          },
          {
              name:"SemiBold",
              value:600
          },
          {
              name:"SemiBold Italic",
              value:600
          },
          {
              name:"Bold",
              value:700
          },
          {
              name:"Bold Italic",
              value:700
          },
          {
              name:"ExtraBold ",
              value:800
          },
          {
              name:"ExtraBold Italic",
              value:800
          },
          {
              name:"Black",
              value:900
          },
          {
              name:"Black Italic",
              value:900
          },
      ]
  },
]